import React from 'react';
import Tippy from '@tippy.js/react';
import { Action } from './style';
import 'tippy.js/dist/tippy.css';

const Tip = props => {
  const {
    style = {},
    content,
    placement,
    action,
    editClick,
    deleteClick,
    reportClick,
    editTestId,
    deleteTestId,
    reportTestId,
    ...rest
  } = props;

  const renderAction = () => {
    return (
      <div
        style={{ paddingTop: '5px', paddingLeft: '5px', paddingRight: '5px' }}
      >
        {editClick ? (
          <Action onClick={editClick} data-testid={editTestId}>
            Edit
          </Action>
        ) : null}
        {deleteClick ? (
          <Action onClick={deleteClick} data-testid={deleteTestId}>
            Delete
          </Action>
        ) : null}
        {reportClick ? (
          <Action onClick={reportClick} data-testid={reportTestId}>
            Report
          </Action>
        ) : null}
      </div>
    );
  };
  return (
    <Tippy
      placement={placement ? placement : 'top'}
      touch={true}
      arrow={true}
      allowHTML={true}
      interactive={true}
      content={
        action ? (
          renderAction()
        ) : (
          <span style={{ fontSize: '14px', fontWeight: '600', ...style }}>
            {content}
          </span>
        )
      }
      // https://github.com/FezVrasta/popper.js/issues/535
      popperOptions={{
        modifiers: {
          preventOverflow: {
            boundariesElement: 'window',
          },
        },
      }}
      {...rest}
    />
  );
};

export default Tip;
